<template>
  <div class="wrapBox">
    <div class="unifiedBox">
      <span class="title">{{ titleText }}</span>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>
<script>

import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import * as constant from '../../api/constant'
import { Toast } from 'vant'
export default {
  data () {
    return {
      loginPara: {},
      titleText: '努力加载中',
      haveCodeTitleText: '正在请求'
    }
  },
  mounted () {
    console.log(this.$route.query)
    this.loginPara = this.$route.query
    this.unifiedEntry()
  },
  computed: {

  },
  methods: {
    unifiedEntry () {
      // 参数
      const qryPara = 'response_type=code&client_id=' +
        constant.unifiedEntryObj.client_id +
        '&redirect_uri=' + constant.unifiedEntryObj.redirect_uri

      // 拼接学校url
      // get方法 location.href
      // let code = ''
      // const schoolUrl = 'http://www.baidu.com?' + 'test=123'
      // 测试地址
      // const schoolUrl = 'https://result.eolink.com/I1FaxIba9ca8107ea87e505e22df4e09f33468d6a55bd14?uri=/user/points.php'

      // const schoolUrl = constant.unifiedEntryObj.response_uri + '?' + qryPara
      const schoolUrl = constant.unifiedEntryObj.response_uri

      console.log(schoolUrl)
      // window.location.href = 'https://sso.tzc.edu.cn' + schoolUrl

      console.log('@@@@@@@@@@@@@@@', this.$router.query)
      // console.log(this.$$router.query)
      // const para = {

      // }

      api
        .axiosRequestGet('/unifiedApi' + schoolUrl, qryPara)
        .then((res) => {
          console.log('获取请求结果', res)
          if (res.code === common.resCode.OK) {
            this.titleText = this.haveCodeTitleText
            // this.haveCodeLogin()
            //  处理正确的code
            // code = '789ok'
            // todo 调用后续的登录接口 后台控制是哪个账户登录
            // 登录成功 保存相关信息 跳转到预约首页
          } else {
            Toast.fail('数据获取失败，请稍后重试')
            // code = '789error'
            // 认证失败 返回到登录页面
            this.$router.replace('/login')
          }

          // this.$router.replace({
          //   path: '/login',
          //   query: {
          //     code: code
          //   }
          // })
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 登录接口 需要返回个人信息 账号密码
    haveCodeLogin () {
      const para = {
        // access_token: 'CA6DBE6B-AA30-0001-3ECF-1E701CF09760',
        // account: values.account,
        // pwd: md5(values.password)
      }
      const tempPassword = ''
      api
        .axiosRequest(api.urlList.login, para)
        .then((res) => {
          console.log(res)
          if (res.code === common.resCode.OK) {
            Toast.clear()

            if (res.user_info) {
              localStorage.setItem(
                common.keyAccessToken,
                res.access_token
              )
              const passwordCheck = !utils.checkPassword(tempPassword)
              let passwordCheckVal = ''
              if (passwordCheck) {
                passwordCheckVal = '1'
              } else {
                passwordCheckVal = '0'
              }
              localStorage.setItem(
                'passwordCheck',
                passwordCheckVal
              )
              this.getConfig(res.access_token)
              this.$store.commit('USERINFO', JSON.stringify(res.user_info))
              // this.$store.dispatch('clearBuilding')

              // Toast('欢迎' + values.account)
              this.$router.replace('./order')
            }
          } else {
            Toast.fail(common.resMSG[res.code])
          }
        })
        .catch((e) => Toast.fail('网络出错'))
    }
  }
}
</script>
<style scoped lang="scss">
.wrapBox {
  height: 100%;
  .unifiedBox {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-size: 1rem;
      line-height: 1.875rem;
    }
  }
}
</style>
